import { render, staticRenderFns } from "./RedPoint.vue?vue&type=template&id=79b2628d"
import script from "./RedPoint.vue?vue&type=script&lang=ts"
export * from "./RedPoint.vue?vue&type=script&lang=ts"
import style0 from "./RedPoint.vue?vue&type=style&index=0&id=79b2628d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports